import React, { useEffect, useRef, useState } from 'react';
import { observer } from "mobx-react";
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { PaymentTypeEnum } from 'ReactApp/Types/enum';
import { autorun } from 'mobx';
// import { serverConfigFromHtmlInstance } from 'ReactApp/Services/ServerConfigFromHtml/ServerConfigFromHtml';
// import DangerouslySetHtmlContent from 'ReactApp/Services/DangerouslySetHtmlContent/DangerouslySetHtmlContent';

type YandexPayWidgetV1Props = {
    paymentType?: PaymentTypeEnum;
    methods?: string[];
    showableCart: ShowableCart;
}

const YandexPayWidgetV1 = observer((props: YandexPayWidgetV1Props) => {

    const ref = useRef(null);
    const yp = window.yp;

    useEffect(() => {
        autorun(() => {
            if (ref === null) {
                return;
            }
            
            yp.createPaymentSession(
                ref.current,
                {
                    totalAmount: props.showableCart.totalBaseSum,
                    availablePaymentMethods: ['SPLIT'],
                },
                () => {
                    $('.cart-form-v1').find('input[name="CartV1Form[paymentType]"][value="${props.paymentType}"]').attr('checked','checked').trigger('change');
                    $('.cart-form-v1').trigger('submit');
                    return true;
                },
                (err) => {
                    console.error('Payment error — ' + err);
                },
            );
        });
    }, []);

    return (
        <div {...{
            style: {
                'position': 'relative',
                'left': '-2rem',
                'width': '30%',
                'maxWidth': '30%',
                'minWidth': '30%',
            },
            'data-yp-widget-id': 'yp-cart-1',
        }} ref={ref} />
    );
    
});

export default YandexPayWidgetV1;
